<template>
  <v-container>
    <v-card>
      <template>
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page.sync="limit"
          :options.sync="options"
          :server-items-length="count"
          :loading="loading"
          :aria-busy="loading"
          loading-text="Loading..."
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              @click="editItem(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
              Edit
            </v-btn>
            <!-- |
            <v-btn
              small
              @click="viewItem(item)"
            >
              View
            </v-btn> -->
            |
            <v-btn
              small
              color="red darken-1"
              dark
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
              Delete
            </v-btn>
          </template>
          <template v-slot:item.active="{ item }">
            <v-switch
              v-model="item.active"
              inset
              @change="activeItem(item)"
            ></v-switch>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { authHeader } from '../_helpers';
import moment from 'moment'

export default {
  name: 'AppDataTable',
  props: ['list_name', 'header_list', 'attribute_list', 'url', 'search_param'],
  data: () => ({
    headers: [],
    list: [],
    count: 0,
    loading: true,
    page: 1,
    limit: 15,
    options: {}
  }),
  watch: {
    options: {
      async handler () {
        await this.getList()
      }
    },
    search_param: {
      async handler () {
        await this.getList()
      }
    }
  },
  async mounted () {
    this.headers = this.header_list
    this.options.sortBy[0] = 'id'
    this.options.sortDesc[0] = 'DESC'
  },
  methods: {
    async getList () {
      this.loading = true
      this.$emit('loading', true)
      try {
        this.page = this.options.page
        let url = `?limit=${this.limit}&page=${this.page}`
        if (this.search_param)
          url += `${this.search_param}`
        if (this.options.sortBy[0]) {
          url = url + `&sortby=${this.options.sortBy[0]}&ordering=${this.options.sortDesc[0] ? 'DESC' : 'ASC'}`
        }
        const result = await this.$http.get(`/back-office${this.url}${url}`, authHeader())
        const count = await this.$http.get(`/back-office${this.url}/count${url}`, authHeader())
        this.count = count.data
        this.list = result.data.map(item => {
          let data = {}
          for (let attribute of this.attribute_list) {
            if (attribute.includes('date') || attribute == 'createdAt' || attribute == 'updatedAt')
              data[attribute] = moment(String(item[attribute])).format('DD MMMM, YYYY hh:mm:ss a')
            else
              data[attribute] = item[attribute]
          }
          return data
        })
      } finally {
        this.loading = false
        this.$emit('loading', false)
      }
    },
    editItem (item) {
      this.$router.push({ name: `${this.list_name}-edit`, params: { id: item.id }});
    },
    viewItem (item) {
      this.$router.push({ name: `${this.list_name}-view`, params: { id: item.id }});
    },
    async deleteItem (item) {
      let confirmation = confirm('Are you sure you want to delete?')
      if (confirmation) {
        await this.$http.delete(`/back-office${this.url}/${item.id}`, authHeader())
        await this.getList()
      }
    },
    async activeItem (item) {
      try {
        await this.$http.put(`/back-office${this.url}/${item.id}`, { active: item.active }, authHeader())
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style>
.v-data-table .v-btn {
  margin: 8px 0;
}
.v-application--is-ltr .v-data-footer__select {
  display: none;
}
</style>
